import * as React from 'react'
import { Helmet } from 'react-helmet'
import { IMetadata } from 'src/type/meta-data'

export const HelmetMeta: React.SFC<IMetadata> = (props) => {
  return (
    <Helmet>
        <title>{props.title}</title>
        {props.description &&
            <meta name="description" content={props.description} />
        }
        {props.keyword &&
            <meta name="keyword" content={props.keyword} />
        }
    </Helmet>
  )
};



// WEBPACK FOOTER //
// ./src/shared/HelmetTitle/HelmetMeta.tsx